import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { SnackBarService } from "app/services/snackbar.service";
import * as moment from "moment";
import { Paciente } from "./paciente";
import { ProfileService } from "./profile.service";


@Component({
    selector: "profile",
    templateUrl: "./profile.component.html",
    styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent {
    profileForm: FormGroup;
    editar = false; //Habilita a edicão 
    infoPaciente = new Paciente; //Armazena os dados Paciente vindo do banco de dados
    phoneMask = "";   
    celMask = "" ;       
   

    constructor(private _formBuilder: FormBuilder,
        private profileService: ProfileService,  
        private progressBar: FuseProgressBarService,    
        private snackService: SnackBarService,  
    ) { }

    ngOnInit(): void {            
        
        const user = JSON.parse(localStorage.getItem("paciente"));      

        this.profileForm = this._formBuilder.group({
            idPaciente: user.idPaciente,
            nomePaciente: [user.nomePaciente, [Validators.required]],
            cpf: [user.cpf, [Validators.required]],
            dataNascimento: [user.dataNascimento, Validators.required],
            telefone: [user.telefone],
            telefoneCelular: [user.telefoneCelular],
            email: [user.email],           
        });
        this.profileForm.disable();
        if (this.infoPaciente.idPaciente) {
        } else {

            this.buscaPaciente();
        }
    }

    async updatePaciente() {
        this.progressBar.show();
        
        if (this.profileForm.valid) {
            try {
                const paciente = this.profileForm.getRawValue();
                if (!paciente.telefone && !paciente.telefoneCelular && !paciente.email) {
                    this.progressBar.hide();
                    
                } else {
                    this.infoPaciente.telefone = paciente.telefone;
                    this.infoPaciente.telefoneCelular = paciente.telefoneCelular
                    this.infoPaciente.eMail = paciente.email;
                    this.profileService.editar(this.infoPaciente).then(
                        res =>{
                            this.mascararcampos(res);
                            this.profileForm.disable();                    
                            this.progressBar.hide();
                            this.snackService.successMessage("Dados Atualizados")
                        }
                    );                              
                }
                
            } catch (error) {
                this.snackService.errorMessage("Ocorreu um erro a atualizar dados")
                this.progressBar.hide();
            }
        }
    }

    async buscaPaciente() {
        this.progressBar.show();
        const resultPacie = await this.profileService.buscar(this.profileForm.controls.idPaciente.value);
        this.infoPaciente = resultPacie;
        this.progressBar.hide();

    }

    habilitarEdicao() {
        const phoneMask = "(00) 0000-0000";   
        const celMask = "(00) 0 0000-0000";   

        this.editar = true;
        this.onPhoneChanged(this.editar, phoneMask, celMask);
        this.profileForm.patchValue({
            telefone: this.infoPaciente.telefone,
            telefoneCelular: this.infoPaciente.telefoneCelular,
            email: this.infoPaciente.eMail,
            situacao: this.infoPaciente.situacao
        });
        this.profileForm.controls['telefone'].enable();
        this.profileForm.controls['telefoneCelular'].enable();
        this.profileForm.controls['email'].enable();
    }

    onPhoneChanged(bollean: Boolean, phoneMask?: any, celMask?: any) {
        if (bollean) {
            this.phoneMask = phoneMask;
            this.celMask = celMask
        } else {
            this.phoneMask = null;
            this.celMask = null;
        }
    }

    cancelaEdicao() {
        this.editar = false
        this.onPhoneChanged(this.editar)
        this.profileForm.disable();       
        const user = JSON.parse(localStorage.getItem("paciente"))
        this.profileForm.patchValue({
            idPaciente: user.idPaciente,
            nomePaciente: user.nomePaciente,
            telefoneCelular:user.telefoneCelular,
            telefone: user.telefone,
            email: user.email,
            cpf: user.cpf,
            dataNascimento: user.dataNascimento,
        });
       // this.ngOnInit();
    }

    mascararcampos(res) {     

        const dataAniversario = this.formateDate(res.dataNascimento)
        
        const usuario = {
            idPaciente: res.idPaciente,
            nomePaciente: res.nomePaciente,
            telefoneCelular: this.celFormatter(res.telefoneCelular),
            telefone: this.celFormatter(res.telefone),
            idConvenio: res.idConvenio,
            email: this.emailFormater(res.eMail),
            cpf: this.cpfFormarter(res.cpf),
            dataNascimento: dataAniversario,
        };
        localStorage.setItem("paciente", JSON.stringify(usuario));
        ProfileService.mudarEmailAtualizado.emit(true);    
        this.cancelaEdicao()
    }

    formateDate(dataNascimento){
        moment.locale('pt');
        const dia = moment(dataNascimento).format('DD')
        const mes = moment(dataNascimento).format('MMMM')
        
        const dataAniversario = dia + " de " + mes;       
        return dataAniversario;
    }


    celFormatter(cel) {
        if (!cel || cel == "Número não cadastrado") {
            return "Número não cadastrado"
        }
        if (cel) {
            let celPhone = "";
            let lastField = cel.split("-")[1];
            let size;
            if (lastField == undefined) {
                lastField = cel.split("")
                size = lastField.length
                if (size > 7) {
                    celPhone = "(**) *****-" + lastField[size - 4] + lastField[size - 3] + lastField[size - 2] + lastField[size - 1];
                } else {
                    celPhone = "Número inválido"
                }

            } else {
                celPhone = "(**) *****-" + lastField;
            }
            return celPhone;
        }
    }

    emailFormater(email) {
        if (email == null) {
            return "Email não cadastrado";
        }
        let emailToShow = "***@***.com";
        let finalEmail = "";
        let provedorEmail = "";
        let emailToShowFinal = "";
        let size;
        if (email) {
            let userEmail = email.split("@")[0]; // salva o inicio do email
            //   emailToShow = "***@" + email.split("@")[1];      
            finalEmail = email.split("@")[1]; // salva o final do email
            provedorEmail = finalEmail.split(".")[0]; // salva o provedor do email                      
            size = provedorEmail.length
            if (userEmail.length > 2) {

                emailToShow =
                    userEmail[0] + "***" + userEmail[userEmail.length - 1] + "@"
                    + provedorEmail[0] + "***" + provedorEmail[size - 1] + ".";

                if (finalEmail.split(".")[2] == undefined) {
                    emailToShowFinal = finalEmail.split(".")[1];
                } else {
                    emailToShowFinal = finalEmail.split(".")[1] + "." + finalEmail.split(".")[2];
                }
            } else {
                if (userEmail[0] == undefined) {
                    return "Email inválido"
                } else {
                    emailToShow =
                        userEmail[0] + "***" + userEmail[userEmail.length - 1] + "@"
                        + provedorEmail[0] + "***" + provedorEmail[provedorEmail.length - 1] + ".";
                    if (finalEmail.split(".")[2] == undefined) {
                        emailToShowFinal = finalEmail.split(".")[1];
                    } else {
                        emailToShowFinal = finalEmail.split(".")[1] + "." + finalEmail.split(".")[2];
                    }
                }
            }
        }
        return emailToShow + emailToShowFinal;
    }

    cpfFormarter(cpf) {
        if (cpf) {
            let cpfField = "";
            let firstFieldShow = cpf.split("")[6] + cpf.split("")[7] + cpf.split("")[8];
            let lastFieldShow = "-" + cpf.split("")[9] + cpf.split("")[10];

            cpfField = "***.***." + firstFieldShow + lastFieldShow;
            return cpfField;
        }
    }

}
